import { render, staticRenderFns } from "./JsonEditor.vue?vue&type=template&id=4c084a4e&scoped=true&lang=pug&"
import script from "./JsonEditor.vue?vue&type=script&lang=js&"
export * from "./JsonEditor.vue?vue&type=script&lang=js&"
import style0 from "./JsonEditor.vue?vue&type=style&index=0&id=4c084a4e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c084a4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/authoring/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c084a4e')) {
      api.createRecord('4c084a4e', component.options)
    } else {
      api.reload('4c084a4e', component.options)
    }
    module.hot.accept("./JsonEditor.vue?vue&type=template&id=4c084a4e&scoped=true&lang=pug&", function () {
      api.rerender('4c084a4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/JsonEditor.vue"
export default component.exports